import React, { useEffect, useState } from 'react';
import JobCard from './JobCard';

export default function SavedJobs() {
	const [saved, setSaved] = useState([]);

	useEffect(() => {
		const raw = localStorage.getItem('saved_jobs');
		if (raw) setSaved(JSON.parse(raw));
	}, []);

	function remove(id) {
		const next = saved.filter((j) => j._id !== id);
		setSaved(next);
		localStorage.setItem('saved_jobs', JSON.stringify(next));
	}

	return (
		<div className="space-y-3">
			{!saved.length ? (
				<p className="text-sm text-gray-500">No saved jobs yet.</p>
			) : (
				saved.map((j) => <JobCard key={j._id} job={j} onSave={(e) => { e?.preventDefault?.(); remove(j._id); }} />)
			)}
		</div>
	);
}


